module.exports = __webpack_public_path__ + "media/images/flags/lr-3a7c494b08f2d0e36a4f5452e3919c92.svg";